import { DependencyList, RefObject, useCallback, useEffect } from "react";

/**
 * Hook that triggers a function clicks outside of the passed ref
 */
// TODO: Convert to options object
const useOutsideAlerter = (
	ref: RefObject<any> | RefObject<any>[],
	action: (event: any) => any,
	triggerOnEvent = "mousedown",
	deps?: DependencyList,
	preventDefault?: boolean,
	enabled?: boolean
) => {
	const handleClickOutside = useCallback(
		(event: any) => {
			if (enabled !== undefined && !enabled) return;

			if (event.target.tagName === "svg") {
				// TODO: This is a hack since if user clicks SVGs within ref the contains check below still does not work!
				return;
			}

			// Any element with data-ignore-outside-click will not trigger the action
			if (event.target.closest("[data-ignore-outside-click]")) {
				return;
			}

			const refs = Array.isArray(ref) ? ref : [ref];

			let isTargetInRef = refs.some((ref) => ref.current && ref.current.contains(event.target));

			if (!isTargetInRef) {
				if (preventDefault) {
					event.preventDefault();
				}

				action(event);
			}
		},
		[action]
	);

	useEffect(() => {
		document.addEventListener(triggerOnEvent, handleClickOutside);

		return () => {
			document.removeEventListener(triggerOnEvent, handleClickOutside);
		};
	}, [ref, handleClickOutside, ...(deps || [])]);
};

export default useOutsideAlerter;
